import { render, staticRenderFns } from "./camera2.vue?vue&type=template&id=54b3a80e&"
import script from "./camera2.vue?vue&type=script&lang=js&"
export * from "./camera2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports